import { render, staticRenderFns } from "./GlobalComponent.vue?vue&type=template&id=3b47e4cc&scoped=true"
import script from "./GlobalComponent.vue?vue&type=script&lang=ts"
export * from "./GlobalComponent.vue?vue&type=script&lang=ts"
import style0 from "./GlobalComponent.vue?vue&type=style&index=0&id=3b47e4cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b47e4cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b47e4cc')) {
      api.createRecord('3b47e4cc', component.options)
    } else {
      api.reload('3b47e4cc', component.options)
    }
    module.hot.accept("./GlobalComponent.vue?vue&type=template&id=3b47e4cc&scoped=true", function () {
      api.rerender('3b47e4cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GlobalComponent.vue"
export default component.exports